const TextNavBackground = ({ title }) => {
  return (
    <section className="pt-32 pb-16 px-8 md:px-12 bg-red-600 dark:bg-green-800 break-words">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-white">{title}</h1>
      </div>
    </section>
  );
};

export default TextNavBackground;
